/**
 * Collapsible "Details" affordance revealing an entity's publisher metadata
 * panel. Shared by the ADSP concept and creative headers so each entity keeps
 * the same on-demand metadata reveal the Google ad view offers.
 */
import React, { useState } from 'react';
import Column from '@amzn/meridian/column';
import Link from '@amzn/meridian/link';
import { useTranslation } from 'src/arb-wrapper';
import type { PublisherEntityDto } from 'src/store/generated/leela-api-generated';
import { readDetailMetadata } from './adspEntityHelpers';
import { EntityMetadataDetails } from './EntityMetadataDetails';

interface EntityDetailsToggleProps {
  entity: PublisherEntityDto;
  testId: string;
}

export const EntityDetailsToggle: React.FC<EntityDetailsToggleProps> = ({ entity, testId }) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Column spacing="200">
      <Link
        data-testid={`${testId}-show-details`}
        type="secondary"
        onClick={() => { setShowDetails(prev => !prev); }}
      >
        {t('ads_manager_details')}
      </Link>
      {showDetails && (
        <EntityMetadataDetails
          layout="row"
          metadata={readDetailMetadata(entity)}
          testId={`${testId}-metadata`}
        />
      )}
    </Column>
  );
};
